type MapFilter = {
    bounds: [Array<string>, Array<string>];
    latitude: string;
    longitude: string;
    radius: string;
};

export function deserializeMap(value: any): MapFilter {
    const radius = value.radius;
    const latitude = value.latitude;
    const longitude = value.longitude;
    // @ts-ignore
    const sw = value.southWest ? value.southWest.split(',').map((v) => v.trim()) : ['0', '0'];
    // @ts-ignore
    const ne = value.northEast ? value.northEast.split(',').map((v) => v.trim()) : ['0', '0'];

    return {
        bounds: [sw, ne],
        latitude: latitude,
        longitude: longitude,
        radius: radius,
    };
}
